<template>
    <a-col :span="24" :md="8" class="mb-24">
        <a-card :loading="appointment.isLoading" :bordered="false" class="header-solid h-full">
            <template #title>
                <div style="display:flex; flex-direction: row;">                     
                    <a-avatar
                        :size="74"
                        shape="square"
                        :src="visitorImageUrl"
                    />
                    
                    <div style="margin-left: 20px;">
                        <h6 class="font-semibold mb-10">{{ visitorName }}</h6>
                        <p style="font-weight: 600"> {{ visitorCompany }} </p>
                        <p style="font-weight: 600"> {{ visitorContact }} </p>
                    </div>
                </div>
            </template>
            <template #extra>
                <a-badge :class="badgeCssClass" :count="appointmentType" />
            </template>
            <p style="font-weight: 600; color: black;"> {{ appointmentTopic }} </p>
            <hr style="margin: 18px 0;border: none;height: 1px;background-color: #f5f5f5;background-image: linear-gradient(90deg,transparent,rgba(0,0,0,.4),transparent);opacity: .25;">
            <div class="ant-row-flex ant-row-flex-middle" style="margin: -12px;">
                <div class="ant-col" style="padding: 12px;">
                    <!-- <h6 class="font-semibold text-md mb-0">{{ personCount }}</h6>
                    <p class="font-semibold text-muted mb-0">{{ $t('appointment-fields.participants') }}</p> -->
                </div>
                <div class="ml-auto ant-col" style="padding: 12px; text-align: end">
                    <h6 class="font-semibold text-md mb-0">{{ date }}</h6>
                    <p class="font-semibold text-muted mb-0">{{ dateCaption }}</p>
                </div>
            </div>
        </a-card>
    </a-col>
</template>

<script>
export default {
    props: {
        appointment: {
            type: Object,
            required: true
        }
    },
    computed: {
        visitorImageUrl() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.imageUrl && this.appointment.visitor.imageUrl.length > 0)
                return this.appointment.visitor.imageUrl;
            return '/images/default-avatar.jpg';
        },
        applicationDate() {
            if (this.appointment && this.appointment.dateCreated) {
                return this.$d(new Date(this.appointment.dateCreated), 'short');
                // return DateHelpers.formatToReadableDate(this.appointment.dateCreated);
            }
            return '';
        },
        visitorName() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.fullName)
                return this.appointment.visitor.fullName;
            return '';
        },
        visitorCompany() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.company)
                return this.appointment.visitor.company;
            return '';
        },
        visitorContact() {
            if (this.appointment && this.appointment.visitor && this.appointment.visitor.mobile)
                return this.appointment.visitor.mobile;
            return '';
        },
        officialImageUrl() {
            if (this.appointment && this.appointment.official && this.appointment.official.imageUrl && this.appointment.official.imageUrl.length > 0)
                return this.appointment.official.imageUrl;
            return '/images/default-avatar.jpg';
        },
        officialName() {
            if (this.appointment && this.appointment.official && this.appointment.official.name)
                return this.appointment.official.name;
            return '';
        },
        badgeCssClass() {
            if (this.appointment) {
                if (this.appointment.type == 'IN_PERSON')
                    return 'in-person'
                else if (this.appointment.type == 'ONLINE')
                    return 'online';
            }
            return '';
        },   
        appointmentType() {
            if (this.appointment && this.appointment.type) {
                if (this.appointment.type == 'IN_PERSON')
                    return this.$t('appointment-types.in-person');
                else if (this.appointment.type == 'ONLINE')
                    return this.$t('appointment-types.online');
            }
            return '';
        },
        topic() {
            if (this.appointment && this.appointment.topic) {
                if (this.appointment.topic.length > 60)
                    return this.appointment.topic.substring(0, 60) + '...';
                else
                    return this.appointment.topic;
            }
            return '';
        },
        badgeCssClass() {
            if (this.appointment) {
                if (this.appointment.type == 'IN_PERSON')
                    return 'in-person'
                else if (this.appointment.type == 'ONLINE')
                    return 'online';
            }
            return '';
        },   
        appointmentType() {
            if (this.appointment && this.appointment.type) {
                if (this.appointment.type == 'IN_PERSON')
                    return this.$t('appointment-types.in-person');
                else if (this.appointment.type == 'ONLINE')
                    return this.$t('appointment-types.online');
            }
            return '';
        },
        personCount() {
            if (this.appointment) {
                return this.$n(this.appointment.personCount);
            }
            return '';
        },
        dateCaption() {
            if (this.appointment.status == 'APPLIED') {
                return this.$t('appointment-fields.applied-on');
            } else {
                return this.$t('appointment-fields.date');
            }
        },
        appointmentTopic() {
            if (this.appointment && this.appointment.topic) {
                if (this.appointment.topic.toLowerCase().includes('personal'))
                    return this.$t('appointment-fields.topic-personal');
                else if (this.appointment.topic.toLowerCase().includes('official'))
                    return this.$t('appointment-fields.topic-official');
            }
            return '';
        },
        date() {
            if (this.appointment) {
                if (this.appointment.status == 'APPLIED') {
                    return this.$d(new Date(this.appointment.dateCreated), 'short');
                } else {
                    if (this.appointment.dateTs) {
                        let h = this.appointment.hour;
                        let suffix = this.$t('time.am');
                        if (h > 12) {
                            h -= 12;
                            suffix = this.$t('time.pm');
                        }

                        let time = this.$n(h).padStart(2, this.$n(0) + '') + ":" + this.$n(this.appointment.min).padStart(2, this.$n(0) + '') + ' ' + suffix;
                        console.log(this.appointment.dateTs);
                        let date = this.$d(new Date(this.appointment.dateTs), 'short');
                        return date + ", " + time;
                    } else {
                        return '';
                    }
                    
                }
            }
        }
                  

    }
}
</script>
